import { apiService } from '@afterpaytouch/portal-api'
import { createTransform } from 'redux-persist'
import { QueryStatus } from '@reduxjs/toolkit/query'

type RTKQueryState = Record<string, any> & {
  queries?: Record<string, { status?: QueryStatus }>
}

export const cleanupRTKQueryState = createTransform(
  (inboundState: RTKQueryState, key): RTKQueryState => {
    if (key !== apiService.service.reducerPath) {
      return inboundState
    }

    const { queries = {} } = inboundState

    // https://github.com/reduxjs/redux-toolkit/issues/2955
    // pending queries won't even work with force invalidate tags, so have to remove it to avoid unknown problems
    const filteredQueries = Object.fromEntries(Object.entries(queries).filter(([_, entry]) => entry?.status !== QueryStatus.pending))

    return {
      ...inboundState,
      queries: filteredQueries,
      subscriptions: {},
      mutations: {},
    }
  },
  (outboundState) => outboundState,
  { whitelist: [apiService.service.reducerPath] }
)
